import { render, staticRenderFns } from "./clientTop.vue?vue&type=template&id=22f81ac0&scoped=true"
import script from "./clientTop.vue?vue&type=script&lang=js"
export * from "./clientTop.vue?vue&type=script&lang=js"
import style0 from "./clientTop.vue?vue&type=style&index=0&id=22f81ac0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f81ac0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f81ac0')) {
      api.createRecord('22f81ac0', component.options)
    } else {
      api.reload('22f81ac0', component.options)
    }
    module.hot.accept("./clientTop.vue?vue&type=template&id=22f81ac0&scoped=true", function () {
      api.rerender('22f81ac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/clientAnddistributionChild/clientTop.vue"
export default component.exports